<template>
  <div>
    <div class="dottedBox" style="width: 81%; position: absolute; bottom: -5rem; right: -61rem; height: 9rem">
      <label class="custom-file">
        <div class="text-center mt-n4">
          <input
            type="file"
            class="custom-file-input"
            id="exampleInputFile"
            accept="image/png, image/jpeg, image/jpg"
            size="3000000"
            aria-describedby="fileHelp"
            ref="fileToUpload"
            multiple
            style="height: 153px; position: absolute; left: -7%; width: 114%"
          />
          <span class="k-icon k-i-image" size="3x" style="margin-top: 57px"></span><br />
          <p>
            {{ $t("imageInputComp.dragYourImageHereOr") }} <a href="#">{{ browse }}</a>
          </p>
        </div>
      </label>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ImageInputComp",
  data() {
    return {
      browse: this.$t("imageInputComp.browse")
    };
  }
});
</script>

<style scoped>
.k-icon {
  font-size: 2rem !important;
}
</style>
